import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'recompose';

import { Button } from 'shared/components';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';

import theme from './FetchedByAnotherProviderModal.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onOk: PropTypes.func.isRequired,
};

const FetchedByAnotherProviderModal = ({ intl, onOk }) => (
  <React.Fragment>
    <div className={ theme.body }>
      <FormattedMessage
        id="AdminConsole.Appointments.DetailedView.AppointmentDetails.EditDialog.ApptIsFetched"
        defaultMessage="** Pay attention you are updating the Provider to an appointment which is already fetched by another provider"
      />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="submit-provider-warning-button"
        label={ intl.formatMessage({
          id: 'AdminConsole.Appointments.DetailedView.AppointmentDetails.EditDialog.ApptIsFetched.Ok',
          defaultMessage: '** Ok',
        }) }
        onClick={ onOk }
      />
    </div>
  </React.Fragment>
);

FetchedByAnotherProviderModal.propTypes = propTypes;

export default compose(
  withEscHandler,
  injectIntl,
)(FetchedByAnotherProviderModal);
